import { createContext, FC, useState } from 'react'

export type Data = {
  id?: string
  title: string
  description: string
  date: Date
  hour_start: Date
  hour_end: Date
  url: string
  cycle: string
  category: string
  image?: File
  management: object
  active: boolean
}

export interface DataContext {
  formData: Data,
  handleChangeFormData: (data: Partial<Data>) => void,
  handleUpdateFormData: (data: Partial<Data>) => void,
}

const initialData: Data = {
  id: '',
  title: '',
  description: '',
  date: new Date(),
  hour_start: new Date(),
  hour_end: new Date(),
  url: '',
  cycle: '',
  category: '',
  image: undefined,
  management: [],
  active: true,
}

export const Context = createContext<DataContext>({
  formData: initialData,
  handleChangeFormData: (data: Partial<Data>) => {},
  handleUpdateFormData: (data: Partial<Data>) => {},
})

const NewFormDataProvider: FC = (props) => {
  const [formData, setFormData] = useState<Data>(initialData)

  const handleChangeFormData = (data: Partial<Data>) =>
    setFormData({ ...formData, ...data })

  const handleUpdateFormData = (data: Partial<Data>) => {
    if (data && data?.id) {
      setFormData({
        ...formData,
        id: data.id,
        title: data.title || initialData.title,
        description: data.description || initialData.description,
        date: data.date || initialData.date,
        hour_start: data.hour_start || initialData.hour_start,
        hour_end: data.hour_end || initialData.hour_end,
        url: data.url || initialData.url,
        image: data.image || initialData.image,
        cycle: data.cycle || initialData.cycle,
        category: data.category || initialData.category,
        management: data.management || initialData.management,
        active: data.active || false
      })
    }
  }

  return (
    <Context.Provider value={{ formData, handleChangeFormData, handleUpdateFormData }}>
      {props.children}
    </Context.Provider>
  )
}

export default NewFormDataProvider
